import { useSmartrrCustomerSelector } from "@customer-app/state/typedCustomerReduxHooks";
import { useMemo } from "react";

export const useUnavailableVariantsAndDeliveries = (cpsId?: string) => {
  const unavailableVariantsAndDeliveries = useSmartrrCustomerSelector(
    state => state.purchaseStates.unavailableVariantsAndDeliveries
  );

  const shouldBannersBeShown = Boolean(
    unavailableVariantsAndDeliveries.vnts.length || unavailableVariantsAndDeliveries.purchasables.length
  );

  const isDeliveryUnavailable = useMemo(
    () => unavailableVariantsAndDeliveries.deliveries.some(delivery => delivery.purchaseState.id === cpsId),
    [cpsId, unavailableVariantsAndDeliveries.deliveries]
  );

  return useMemo(
    () => ({
      unavailableVariantsAndDeliveries,
      shouldBannersBeShown,
      isDeliveryUnavailable,
    }),
    [unavailableVariantsAndDeliveries, shouldBannersBeShown, cpsId]
  );
};
